import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useForm } from "react-hook-form";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import {
  cancelVisitorPass,
  checkOutVisitor,
  getAllVisitorList,
  getPreviousVisitoryBysearchString,
} from "../../services/VisitorRegistrationService";
import { passTypeDropdown } from "../masters/services/PassTypeService";
import { CancelIcon } from "../../../assets/icons/CommonIcons";
import { PrintIcon } from "../../../assets/CommonAssets";
import {
  CancelDisabledIcon,
  CheckOutIcon,
  DisabledCheckOutIcon,
  DisabledPrintIcon,
} from "../assets/VisitorMAssets";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import PassPrint from "../../prints/PassPrint";
import { format } from "date-fns";
import { GeneratePrint } from "../../../common/components/printModal/GeneratePrint";
import { Tooltip } from "@mui/material";

const UserAction = [
  {
    id: 1,
    permission: "Create",
    isAction: false,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  // { id: 2, permission: "Edit", isAction: true, menuId: null, functionalityId: null, menuKey: null },
  {
    id: 3,
    permission: "Cancel",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "Print",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "CheckOut",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
];

const defaultValues = {
  searchableSelect: null,
  passType: null,
  fromdate: null,
  toDate: null,
};
function VisitorListing() {
  const { control, watch, setValue, register } = useForm({
    mode: "onChange",
    defaultValues,
  });
  const location = useLocation();
  console.log("locationlocation", location);
  //action are static
  const passPrintref = useRef(null);
  const [userAction, setUserAction] = useState(UserAction);
  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isBackDrop, setIsBackdrop] = useState(false);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [cancelConfirmationModal, setCancelConfirmationModal] = useState(false);
  const [checkOutConfirmationModal, setCheckOutConfirmationModal] =
    useState(false);
  const [searchString, setSearchString] = useState(null);
  const [passTypeOptions, setPassTypeOptions] = useState([]);
  const [visitorOptions, setVisitorOptions] = useState([]);
  const [listingObject, setListingObject] = useState({
    page: 0,
    size: rowsPerPage,
    searchString: "",
    searchId: searchString?.id ? searchString?.id : null,
    fromDate: null,
    toDate: null,
    passTypeId: null,
    // menuId: location?.state?.menuId,
    statusId: null,
    whomToMeetId: null,
  });
  console.log("listingObjectlistingObject", listingObject);
  const navigate = useNavigate();

  const passTypeId = watch("passType");
  const fromDate = watch("fromdate");
  const toDate = watch("toDate");

  console.log("visitor row", selectedRow);

  const populateTable = (forPagination) => {
    let searchObj = {
      page: !forPagination ? 0 : page,
      searchString: "",
      size: rowsPerPage,
      searchId: searchString?.value ? searchString?.value : null,
      fromDate: fromDate ? format(new Date(fromDate), "yyyy-MM-dd") : null,
      toDate: toDate ? format(new Date(toDate), "yyyy-MM-dd") : null,
      passTypeId: passTypeId?.id ? passTypeId?.id : null,
      // menuId: location?.state?.menuId,
      statusId: null,
      whomToMeetId: null,
    };
    if (page === 0) {
      setIsShowSpinner(true);
    }
    getAllVisitorList(searchObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 204) {
          console.log("resresresres", res);

          if (forPagination === true) {
            setDataResult((prevData) => [...prevData, ...res.result]);
            setIsShowSpinner(false);
          } else {
            setDataResult(res.result);
            setIsShowSpinner(false);
            setPage(0);
          }
          setCount(res.count);
        } else {
          errorAlert(res.message);
          setIsShowSpinner(false);
        }
        // setUserAction(res?.actions);
      })
      .catch((error) => {
        console.log(error);

        setIsShowSpinner(false);
      });
  };

  // Function to handle the deletion confirmation
  const handleConfirmToCancelPass = () => {
    setCancelConfirmationModal(false);
    setIsBackdrop(true);
    cancelVisitorPass(selectedRow?.Id)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setIsBackdrop(false);
          setCancelConfirmationModal(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res.message);
          setPage(0);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setIsBackdrop(false);
      });
  };
  const handleConfirmToCheckOut = () => {
    setCheckOutConfirmationModal(false);
    setIsBackdrop(true);
    checkOutVisitor(selectedRow?.Id)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200) {
          setIsBackdrop(false);
          setCheckOutConfirmationModal(false);
          populateTable();
          setSelectedRow(null);
          successAlert(res.message);
          setPage(0);
        }
      })
      .catch((error) => {
        errorAlert(error.message);
        setIsBackdrop(false);
      });
  };

  const renderInput = useCallback((row, index, header) => {
    console.log("headerheaderheader", header);

    return (
      <div className="py-1">
        {header.toLowerCase() === "status" && (
          <button
            className={`w-28 whitespace-nowrap py-0.5 capitalize px-2 text-center text-[14px] font-normal rounded-lg border
                         ${
                           row?.["Status"]?.toLowerCase() === "open"
                             ? "text-[#FFA500] bg-[#FFE7CC] border-[#FFA500]"
                             : row?.["Status"]?.toLowerCase() === "cancelled"
                             ? "text-[#8E24AA] bg-[#FBEBFF] border-[#8E24AA]"
                             : row?.["Status"]?.toLowerCase() === "rejected"
                             ? "text-[#D32F2F] bg-[#FBEBFF] border-[#D32F2F]"
                             : row?.["Status"]?.toLowerCase() === "accepted"
                             ? "text-[#1976D2] bg-[#E3F0FF] border-[#1976D2]"
                             : row?.["Status"]?.toLowerCase() === "completed"
                             ? "text-[#388E3C] bg-[#D1FFDE] border-[#388E3C]"
                             : ""
                         } 
                                            `}
            type="button"
          >
            {row?.["Status"]}
          </button>
        )}

        {header === "Visit Type" && (
          <p>{row["Visit Type"] ? "Multi" : "Single"}</p>
        )}
        {header === "Whom To Meet" && (
          <p>
            {row["Whom To Meet"] && row["Whom To Meet"] !== ""
              ? row["Whom To Meet"]
              : "-"}
          </p>
        )}
        {header === "Company Name" && (
          <p>{row["Company Name"] ? row["Company Name"] : "-"}</p>
        )}
        {header === "Visited Mobile No" && (
          <p>{row["Visited Mobile No"] ? row["Visited Mobile No"] : "-"}</p>
        )}
        {header === "Department" && (
          <p>{row["Department"] ? row["Department"] : "-"}</p>
        )}
        {header === "Location" && (
          <p>{row["Location"] ? row["Location"] : "-"}</p>
        )}
        {header === "Check Out" && (
          <p>{row["Check Out"] ? row["Check Out"] : "-"}</p>
        )}
        {header === "Patient Name" && (
          <p>{row["Patient Name"] !== "" ? row["Patient Name"] : "-"}</p>
        )}
        {header === "Age" && <p>{row["Age"] ? row["Age"] : "-"}</p>}
        {header === "Patient Department" && (
          <p>{row["Patient Department"] ? row["Patient Department"] : "-"}</p>
        )}
        {header === "Patient Ward" && (
          <p>{row["Patient Ward"] ? row["Patient Ward"] : "-"}</p>
        )}
        {header === "Bed No" && <p>{row["Bed No"] ? row["Bed No"] : "-"}</p>}
      </div>
    );
  }, []);

  console.log("selectedRow", selectedRow);

  // Function to render actions in the table
  const renderActions = (row, index) => {
    const showEnabledIcons =
      (row?.["Pass Type"]?.toLowerCase() === "patient visitor" &&
        row?.["Status"] === "Open") ||
      (row?.["Pass Type"]?.toLowerCase() !== "patient visitor" &&
        row?.["Status"] === "Accepted");

    return (
      <div className="flex gap-1">
        {userAction?.map((option, i) => (
          <div key={i}>
            {showEnabledIcons ? (
              <>
                {option.isAction && option.permission === "Cancel" && (
                  <Tooltip title="Cancel">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedRow(row);
                        setCancelConfirmationModal(true);
                      }}
                    >
                      <CancelIcon />
                    </button>
                  </Tooltip>
                )}

                {option.isAction && option.permission === "Print" && (
                  <Tooltip title="Print">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedRow(row);
                        setTimeout(() => {
                          GeneratePrint(passPrintref);
                        }, 500);
                      }}
                    >
                      <PrintIcon />
                    </button>
                  </Tooltip>
                )}

                {option.isAction && option.permission === "CheckOut" && (
                  <CheckOutIcon
                    title="Check Out"
                    type="button"
                    onClick={() => {
                      setCheckOutConfirmationModal(true);
                      setSelectedRow(row);
                    }}
                  />
                )}
              </>
            ) : (
              <>
                {option.isAction && option.permission === "Cancel" && (
                  <CancelDisabledIcon type="button" />
                )}
                {option.isAction && option.permission === "Print" && (
                  <DisabledPrintIcon type="button" />
                )}
                {option.isAction && option.permission === "CheckOut" && (
                  <DisabledCheckOutIcon type="button" />
                )}
              </>
            )}
          </div>
        ))}
      </div>
    );
  };

  const renderTableHeader = () => {
    return (
      <>
        <div>
          <h1 className="font-semibold  text-[16px] ">Visitor List</h1>
        </div>
      </>
    );
  };
  useEffect(() => {
    //pass type Options
    passTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          const newOption = {
            id: null,
            label: "All",
            value: null,
          };
          res.result.unshift(newOption);
          setValue("passType", res.result[0]);
          setPassTypeOptions(res.result);
        }
      })
      .catch((error) => {
        setPassTypeOptions([]);
      });
  }, []);

  useMemo(() => {
    populateTable();
  }, [
    listingObject?.passTypeId,
    listingObject?.searchId,
    listingObject?.fromDate,
    listingObject?.toDate,
    listingObject?.searchString,
    listingObject?.searchId,
    listingObject?.whomToMeetId,
  ]);
  return (
    <div className="px-2 mt-12">
      <div>
        {/* {CommonHeading("Visitor Listing")} */}
        <div>
          <h1 className="text-center mt-4 text-black font-bold text-xl font-Poppins my-2">
            Visitor Listing
          </h1>
        </div>

        {/* <div className='flex justify-between items-center mt-3'> */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4  gap-2">
          <div className="w-full md:w-3/3 lg:w-full ">
            <SearchDropdown
              control={control}
              name="searchableSelect"
              placeholder="Search by Visitor Name"
              dataArray={visitorOptions}
              isClearable={true}
              handleInputChange={(e) => {
                if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                  getPreviousVisitoryBysearchString(e)
                    .then((response) => response.data)
                    .then((res) => {
                      setVisitorOptions(res.result);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                } else {
                  setVisitorOptions([]);
                }
              }}
              inputRef={{
                ...register("searchableSelect", {
                  onChange: (e) => {
                    let value = e?.target?.value;
                    if (value !== null) {
                      setSearchString(value);
                    } else {
                      setSearchString(null);
                      setListingObject((listingObject) => ({
                        ...listingObject,
                        searchId: null,
                      }));
                    }
                  },
                }),
              }}
              searchIcon={true}
            />
          </div>
          <div>
            <DropdownField
              control={control}
              placeholder="Pass Type"
              name="passType"
              isSearchable={true}
              isClearable={true}
              dataArray={passTypeOptions}
              inputRef={{
                ...register("passType", {
                  onChange: (e) => {
                    let value = e?.target?.value;
                    console.log("valuevaluevaluevaluevalue", value);
                    if (value === null) {
                      setListingObject((listingObject) => ({
                        ...listingObject,
                        passTypeId: null,
                      }));
                    }
                  },
                }),
              }}
            />
          </div>
          {/* <div className='grid grid-cols-2 items-center gap-x-2'>
                            <DatePickerField
                                name="fromdate"
                                label="From Date"
                                control={control}
                                inputFormat="dd-MM-yyyy"
                                // error={errors.requestedDate}
                                slotProps={{ textField: { size: "small" } }}
                            />
                            <DatePickerField
                                name="toDate"
                                label="To Date"
                                control={control}
                                inputFormat="dd-MM-yyyy"
                                // error={errors.requestedDate}
                                slotProps={{ textField: { size: "small" } }}
                            />

                        </div> */}
          <div className="flex justify-between lg:col-span-2 ">
            <div className="flex  flex-wrap  gap-2">
              <CommonButton
                searchIcon={true}
                className={"px-4 rounded-md bg-customBlue text-white"}
                onClick={() => {
                  setListingObject((listingObject) => ({
                    ...listingObject,
                    searchString: "",
                    searchId: searchString?.value ? searchString?.value : null,
                    fromDate: fromDate
                      ? format(new Date(fromDate), "yyyy-MM-dd")
                      : null,
                    toDate: toDate
                      ? format(new Date(toDate), "yyyy-MM-dd")
                      : null,
                    passTypeId: passTypeId?.id ? passTypeId?.id : null,
                    statusId: null,
                    whomToMeetId: null,
                  }));
                  populateTable();
                }}
              />
              <CommonButton
                label={"Reset"}
                className=" border border-customRed text-customRed "
                onClick={() => {
                  setSearchString(null);
                  setListingObject((listingObject) => ({
                    ...listingObject,
                    searchString: "",
                    searchId: null,
                    fromDate: null,
                    toDate: null,
                    passTypeId: null,
                  }));
                  setValue("searchableSelect", null);
                  setValue("passType", null);
                  setValue("fromdate", null);
                  setValue("toDate", null);
                }}
              />
            </div>
            <div className="">
              {userAction?.map((option) =>
                !option.isAction && option.permission === "Create" ? (
                  <CommonButton
                    key={option.id}
                    label="New Visitor"
                    className="modalOpenButton bg-white border border-[#073763]  text-[#073763] px-5"
                    onClick={() => {
                      navigate("/visitorManagement/visitorRegistration");
                    }}
                  />
                ) : null
              )}
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>

      <div className="">
        {isShowSpinner ? (
          <div className="flex justify-center my-28">
            <LoadingSpinner />
          </div>
        ) : (
          <div>
            {dataResult && dataResult?.length > 0 ? (
              <CommonDynamicTablePaginationNew
                dataResult={dataResult}
                rowsPerPage={rowsPerPage}
                renderActions={renderActions}
                renderInput={renderInput}
                renderTableHeader={renderTableHeader}
                setPage={setPage}
                tableClass="capitalize h-[415px]"
                count={count}
                page={page}
                populateTable={populateTable}
                highlightRow={false}
                setRowsPerPage={setRowsPerPage}
                removeHeaders={[
                  "Id",
                  "Image",
                  "Luggaage",
                  "Vehicle Details",
                  "Whom To Meet Doctor Id",
                  "Whom To Meet Employee Id",
                  "Patient Id",
                  "Admission Id",
                ]}
                editableColumns={[
                  "Status",
                  "Visit Type",
                  "Company Name",
                  "Visited Mobile No",
                  "Department",
                  "Location",
                  "Whom To Meet",
                  "Check Out",
                  "Patient Name",
                  "Age",
                  "Patient Department",
                  "Patient Ward",
                  "Bed No",
                ]}
              />
            ) : (
              <>
                {!isShowSpinner && (
                  <p className="text-center  my-28 w-full text-gray-600">
                    No Record Found<span className="animate-pulse">...</span>
                  </p>
                )}
              </>
            )}
          </div>
        )}
      </div>

      <div ref={passPrintref} className="hidden print:block">
        <PassPrint passData={selectedRow} />
      </div>

      {cancelConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={cancelConfirmationModal}
          confirmationHandleClose={() => {
            setCancelConfirmationModal(false);
            setSelectedRow(null);
          }}
          confirmationSubmitFunc={handleConfirmToCancelPass}
          confirmationMsg={"Are you sure you want to cancel this Visitor Pass?"}
          confirmationButtonMsg={"Yes, Cancel"}
          confirmationLabel={"Confirmation"}
        />
      )}
      {checkOutConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={checkOutConfirmationModal}
          confirmationHandleClose={() => {
            setCheckOutConfirmationModal(false);
            setSelectedRow(null);
          }}
          confirmationSubmitFunc={handleConfirmToCheckOut}
          confirmationMsg={"Are you sure you want to check out this visitor"}
          confirmationButtonMsg={"Yes, Check Out"}
          confirmationLabel={"Confirmation"}
        />
      )}

      {isBackDrop && <CommonBackDrop openBackdrop={isBackDrop} />}
    </div>
  );
}

export default VisitorListing;
